import { BaseApiService } from './base-api.service';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import {
  IcpIntelAggregationDto,
  IcpIntelCategoryResponseDto,
  IcpIntelInferenceJobDto,
  IcpIntelJobDto,
  IcpIntelJobsDto,
  IcpIntelJobsQueryDto,
  ListItemDto,
} from '../../dto';
import { HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AggregateApiService {

  private baseUrl: string = 'service/contactcloud';

  constructor(private readonly baseApiService: BaseApiService) {
  }

  aggregate(request: object): Observable<IcpIntelAggregationDto> {
    return this.baseApiService.post(
      this.baseUrl + '/aggregate', request,
      { showError: true}
    );
  }

  getAggregationJob(jobUUID: string): Observable<IcpIntelJobDto> {
    return this.baseApiService.get(this.baseUrl + '/icpintel/jobs', {
      params: new HttpParams({fromObject: { jobUUID }})
    });
  }

  getAggregationJobs(query: IcpIntelJobsQueryDto): Observable<IcpIntelJobsDto> {
    return this.baseApiService.get(this.baseUrl + '/icpintel/jobs/search', {
      params: new HttpParams({fromObject: query as any ?? {}}),
      showError: true
    });
  }

  getAggregationJobByUUID(job_uuid: string): Observable<IcpIntelJobDto> {
    return this.getAggregationJobs({ job_uuid, page_size: 1 }).pipe(
      map(({ jobs }: IcpIntelJobsDto) => jobs.pop() ?? null),
    );
  }

  viewAggregationJob(jobUUID: string): Observable<IcpIntelJobDto> {
    return this.baseApiService.get(this.baseUrl + '/icpintel/jobs/view-profile', {
      params: new HttpParams({fromObject: { jobUUID }}),
      showError: true
    });
  }

  reAggregationJob(jobUUID: string): Observable<void> {
    return this.baseApiService.post(`${this.baseUrl}/icpintel/jobs/${jobUUID}/reprofile`, null);
  }

  setAggregationJobName(jobUUID: string, jobName: string): Observable<IcpIntelJobDto> {
    return this.baseApiService.put(
      this.baseUrl + '/icpintel/jobs/name',
      null,
      { params: new HttpParams({fromObject: { jobUUID, jobName }}), showError: false },
    );
  }

  getJobSuppressionList(jobUUID: string): Observable<ListItemDto> {
    return this.baseApiService.post(`${this.baseUrl}/icpintel/jobs/${jobUUID}/suppression`, null, { showError: true });
  }

  getCategories(): Observable<IcpIntelCategoryResponseDto> {
    return this.baseApiService.get(this.baseUrl + '/techno/categories', { showError: true });
  }

  addInferenceJob(jobUUID: string): Observable<IcpIntelInferenceJobDto> {
    return this.baseApiService.post(`${this.baseUrl}/icpintel/jobs/${jobUUID}/inference`);
  }

  getInferenceJob(jobUUID: string): Observable<IcpIntelInferenceJobDto> {
    return this.baseApiService.post(`${this.baseUrl}/icpintel/jobs/${jobUUID}/inference/result`);
  }

  inferenceRetry(jobUUID: string): Observable<void> {
    return this.baseApiService.post(`${this.baseUrl}/icpintel/jobs/${jobUUID}/inference/retry`);
  }
}
